export default "__VITE_ASSET__CLJPgJYH__"